import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {EvkHttpService, MessageCrudService, WizardStep} from "@evomatik/evk-common";
import {WizardExpedientesService} from "../../services/wizard-expedientes.service";
import {take, takeUntil} from "rxjs/operators";
import {PasoWizard, WizardInformacion} from "../../../wizard/interface/wizard-informacion.types";
import {ExpedienteCreateService} from "../../services/expediente-create.service";
import {EvkExpedienteModel} from "../../models/evk-expediente.model";
import {EvkSeccionModel} from "../../models/evk-seccion.model";
import {DataWizardService} from '../../../wizard/services/data-wizard.service';
import {ExpedienteUpdateService} from "../../services/expediente-update.service";
import {WizardEventsService} from "../../../wizard/services/wizard-events.service";
import {EvkExpedienteConfigModel} from "../../models/evk-expediente-config.model";
import {BusinessDataService} from "@evomatik/evk-forms";
import { KeycloakService } from 'keycloak-angular';
import {EvkSeccionConfigModel} from "../../models/evk-seccion-config.model";

@Component({
    selector: 'lib-expediente-wizard',
    templateUrl: './expedientes-wizard.component.html',
    styleUrls: ['./expedientes-wizard.component.css']
})
export class ExpedientesWizardComponent implements OnInit {

    @Input()
    idExpedienteConfig: string;

    @Input()
    idExpediente: string;

    @Input()
    usuario?: string;

    @Input()
    username?: string;

    @Input()
    isEdit = false;

    @Output()
    regresarPaginador: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    backPage: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    biosphereConfig: any;

    @Input()
    descargaZipByFolio: boolean;
    
    @Input()
    skipByVersion: boolean;

    wizardInformacion: WizardInformacion;

    expedienteConfig: EvkExpedienteConfigModel;
    expediente: EvkExpedienteModel;

    readOnly: boolean;

    generarFolio = false;

    private _unsubscribeAll: Subject<any>;

    constructor(
        public http: EvkHttpService,
        public messageCrudService: MessageCrudService,
        public wizardExpedientesService: WizardExpedientesService,
        public expedienteCreateService: ExpedienteCreateService,
        public expedienteUpdateService: ExpedienteUpdateService,
        public dataWizardService: DataWizardService,
        public wizardEvents: WizardEventsService,
        private businessData: BusinessDataService,
        private keycloakService: KeycloakService
    ) {
        this._unsubscribeAll = new Subject();
        this.expediente = new EvkExpedienteModel();
    }

    ngOnInit(): void {
        this.wizardExpedientesService.getExpedienteConfigAndExpediente(this.idExpedienteConfig, this.idExpediente);
        this.wizardExpedientesService.getExpedienteAndConfig.pipe(takeUntil(this._unsubscribeAll)).subscribe((response) => {
            this.setData(response);
            if (this.expediente && this.expediente.id) {
                this.wizardInformacion = this.transformarInformacionWizard(this.expedienteConfig, this.expediente);
            } else {
                this.wizardInformacion = this.transformarInformacionWizard(this.expedienteConfig);
            }
            this.dataWizardService.setDataWizard(this.wizardInformacion);
            this.validarPermiso();
        });
        this.eventosWizard();
        this.definirFuncionesNegocio();
    }

    eventosWizard() {
        this.wizardEvents.onGenerateFolio.pipe(takeUntil(this._unsubscribeAll)).subscribe((response) => {



            if (response.ultimoPaso && (this.expediente.folio == null || this.expediente.folio == '')) {
                this.generarFolio = true;
            } else {
                this.generarFolio = response.generarFolio;
            }
        });
        this.wizardEvents.onDoneSave.pipe(takeUntil(this._unsubscribeAll)).subscribe((response) => {



            if (this.readOnly !== undefined && this.readOnly !== null && this.readOnly) {
                setTimeout(() => {
                    this.wizardEvents.nextOrSave("Solo lectura");
                }, 300);
            } else {


                this.guardarActualizarExpediente(response).subscribe(() => {
                    this.wizardEvents.nextOrSave("Guardado exitoso");
                },(e) => {
                    this.wizardEvents.error(e);
                })
            }
        })
        this.wizardEvents.goToFinishEvent.pipe(takeUntil(this._unsubscribeAll)).subscribe((() => {
            this.regresarPaginador.next();
        }));
    }

    setData(response) {
        this.expedienteConfig = response && response.expedienteConfig ? response.expedienteConfig : null;
        this.expediente = response && response.expediente ? response.expediente : new EvkExpedienteModel();
        /** On case of dynamic URL configured */
        if (this.expedienteConfig.url) {
            /**Setting dynamic URL for update expediente */
            this.expedienteUpdateService.api = this.expedienteConfig.url;
        }
    }

    transformarInformacionWizard(expedienteConfig: EvkExpedienteConfigModel, expediente?: EvkExpedienteModel) {
        let seccionDetalle: EvkSeccionConfigModel = expedienteConfig.seccionConfig.find(value => value.ui === "detalle");
        const informacion: WizardInformacion = {};
        const usoGeneral = expedienteConfig.usoGenerales !== undefined && expedienteConfig.usoGenerales !== null && expedienteConfig.usoGenerales;

        if (this.expediente?.estadoActivo?.estado?.nombre === "FINALIZADO" && seccionDetalle){
            expedienteConfig.seccionConfig = [seccionDetalle];
            let seccionWizard: PasoWizard[] = [];
            seccionWizard.push(this.agregarDetalle(expediente, expedienteConfig, 0));
            informacion.pasos = seccionWizard;
        } else {
            let secciones:  EvkSeccionConfigModel [] = expedienteConfig.seccionConfig;
            let indexConf: number = secciones.findIndex(value => value.ui === "detalle");
            if (indexConf >= 0){
                secciones.splice(indexConf, 1);
            }
            expedienteConfig.seccionConfig = secciones;
            informacion.pasos = this.generarPasos(expedienteConfig, usoGeneral, expediente);
        }
        if (expediente) {
            informacion.idWizardGenerado = expediente.id;
            informacion.edicion = this.isEdit;
            informacion.folioNegocio = expediente.folio ? expediente.folio : expediente.folioProvisional;
        }
        informacion.id = expedienteConfig.id;
        this.validacionTitulo(informacion, usoGeneral, expedienteConfig, expediente);
        const pasosSinValidaciones = expedienteConfig?.seccionConfig?.filter(config => config.roles === undefined || config.roles === null);
        const pasosConValidaciones = expedienteConfig?.seccionConfig?.filter(config => config.roles !== undefined && config.roles !== null);
        let validados = 0;
        pasosConValidaciones.map(config => {
            const roles = config.roles.split(',');
            if (roles.some(rol => this.keycloakService.isUserInRole(rol))) {
                validados++;
            }
        })
        informacion.totalPasos = pasosSinValidaciones.length + validados + (usoGeneral ? 1 : 0);
        informacion.folioDiligencia = expediente?.folioDiligencia;
        informacion.idDiligencia = expediente?.idDiligencia;
        return informacion;
    }

    validacionTitulo(informacion, usoGeneral, expedienteConfig, expediente) {
        if (usoGeneral) {
            const data = this.setInData('datos-general', expediente);
            if (data) {
                informacion.titulo = data.titulo;
                informacion.descripcion = data.descripcion.length > 0 ? data.descripcion : expedienteConfig?.descripcion;
            } else {
                informacion.titulo = expedienteConfig?.nombre;
                informacion.descripcion = expedienteConfig?.descripcion;
            }
            informacion.categoria = expedienteConfig?.nombre;
        } else {
            informacion.titulo = expedienteConfig?.nombre;
            informacion.descripcion = expedienteConfig?.descripcion;
            informacion.categoria = expedienteConfig?.nombre;
        }
    }

    generarPasos(expedienteConfig, usoGeneral?: boolean, expediente?: EvkExpedienteModel): PasoWizard[] {
        const seccionWizard: PasoWizard[] = [];
        if (usoGeneral) {
            seccionWizard.push(this.agregarGeneral(expediente));
            if (!expediente) {
                return seccionWizard;
            }
        }
        let hiddenCount = 0;
        for (const seccion of expedienteConfig.seccionConfig) {
            let addStep = true;
            if (seccion.roles) {
                const roles = seccion.roles.split(',');
                addStep = roles.some(rol => this.keycloakService.isUserInRole(rol));
            }
            if (addStep) {
                seccionWizard.push(PasoWizard.toWizardStep({
                    titulo: seccion.titulo,
                    origen: seccion.origen,
                    descripcion: seccion.descripcion,
                    ui: seccion.ui,
                    generarFolio: seccion.generarFolio,
                    metadataFormId: seccion.metadataFormId ? seccion.metadataFormId : null,
                    nombre: seccion.nombre,
                    discriminador: seccion.discriminador,
                    orden: this.obtenerOrdenSeccion(seccion, usoGeneral) - hiddenCount,
                    requerido: seccion.requerido == undefined ? false : seccion.requerido,
                    inData: this.setInData(seccion.nombre, expediente),
                    datosAdicionales: seccion.datosAdicionales,
                    cardinalidad: seccion.cardinalidad,
                    idBandeja: seccion.idBandeja,
                    formatos: seccion.formatos
                }));
            } else {
                hiddenCount++;
            }
            if (!expediente) {
                return seccionWizard;
            }
        }

        return seccionWizard.sort(({orden: prev}, {orden: curr}) => (prev < curr ? -1 : prev > curr ? 1 : 0));
    }

    obtenerOrdenSeccion(seccion, usoGeneral) {
        return seccion.orden - (usoGeneral ? 0 : 1);
    }

    agregarGeneral(expediente?: EvkExpedienteModel) {
        return WizardStep.toWizardStep({
            titulo: 'Datos Generales',
            origen: 'general',
            descripcion: 'Información del expediente',
            ui: 'general',
            metadataFormId: null,
            requerido: true,
            generarFolio: true,
            orden: 0,
            nombre: 'datos-general',
            inData: this.setInData('datos-general', expediente)
        })
    }

    agregarDetalle(expediente: EvkExpedienteModel, expedienteConfig: EvkExpedienteConfigModel, orden) {
        if(expediente.esDiligencia){
            return WizardStep.toWizardStep({
                titulo: 'Resumen de actuación',
                origen: 'detalle',
                descripcion: '',
                ui: 'detalle-diligencia',
                metadataFormId: null,
                requerido: false,
                orden: orden,
                nombre: 'detalle-diligencia',
                inData: {expediente, expedienteConfig}
            });
        } else {
            let seccionConf = expediente.configuracionExpediente.seccionConfig.find((value) => value.ui === "detalle");
            let indexConf: number = expediente.configuracionExpediente.seccionConfig.findIndex(value => value.ui === "detalle");
            if (indexConf >= 0){
                expediente.configuracionExpediente.seccionConfig.splice(indexConf, 1);
            }
            return WizardStep.toWizardStep({
                titulo: seccionConf.titulo,
                origen: 'detalle',
                descripcion: seccionConf.descripcion,
                ui: 'detalle',
                metadataFormId: null,
                requerido: false,
                orden: orden,
                nombre: 'detalle-expediente',
                inData: {expediente, expedienteConfig}
            });
        }
    }

    setInData(nombre: string, expediente: EvkExpedienteModel) {
        if (expediente && expediente.secciones && expediente.secciones.length > 0) {
            let data = null;
            for (let seccionExpediente of expediente.secciones) {
                if (seccionExpediente.origen == nombre) {
                    data = seccionExpediente.propiedades;
                    if(data){
                        data.expediente = expediente;
                    }else{
                        data = {expediente};
                    }
                    break;
                }
            }
            return data;
        } else {
            return null;
        }
    }

    ngOnDestroy() {
        this.wizardExpedientesService.stopSubscriptions();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._unsubscribeAll.unsubscribe();
    }

    guardarActualizarExpediente(event): Observable<any> {
        this.setDatosBase();
        if (this.expediente.id != null) {
            return this.actualizarExpediente(event);
        } else {
            return this.generarExpediente(event);
        }
    }

    setDatosBase() {
        const configuracionExpediente = new EvkExpedienteConfigModel();
        configuracionExpediente.id = this.idExpedienteConfig;
        this.expediente.configuracionExpediente = configuracionExpediente;
        this.expediente.generarFolio = this.generarFolio;
    }

    generarExpediente(event): Observable<any> {
        return new Observable((observer) => {
            this.expediente.createdBy = this.username;
            this.expediente.origen = {
                origen: event.origen.origen,
                index: event.origen.orden,
                nombre: event.origen.nombre
            };
            this.expediente.secciones = this.transformarSecciones(event.wizardSteps);
            // this.wizardExpedientesService.updateData(this.expediente);
            this.expedienteCreateService.save(this.expediente).pipe(take(1)).subscribe(
                (response) => {
                    this.expediente = response.data;
                    this.wizardExpedientesService.updateData(response.data);
                    this.businessData.addProperty('idExpediente', this.expediente.id);
                    observer.next(response.data);
                }, () => {
                    this.messageCrudService.snackbarMessage('No se ha podido guardar');
                    observer.error('No se ha podido guardar');
                }
            );
        });
    }

    actualizarExpediente(event): Observable<any> {



        return new Observable((observer) => {
            this.expediente.updatedBy = this.username;
            this.expediente.origen = {
                origen: event.origen.origen,
                index: event.origen.orden,
                nombre: event.origen.nombre
            };
            this.expediente.secciones = this.transformarSecciones(event.wizardSteps);
            // this.wizardExpedientesService.updateData(this.expediente);
            this.expedienteUpdateService.edit(this.expediente).pipe(take(1)).subscribe(
                (response) => {
                    this.expediente = response.data;
                    this.wizardExpedientesService.updateData(response.data);
                    observer.next(response.data)
                }, (e) => {
                    this.messageCrudService.snackbarMessage(e && e?.message? e?.message : 'No se ha podido actualizar');
                    observer.error(e && e?.message? e?.message : 'No se ha podido actualizar')
                }
            );
        });
    }

    transformarSecciones(event): EvkSeccionModel[] {
        let secciones: EvkSeccionModel[] = [];
        if (this.expediente.secciones != null && this.expediente.secciones.length > 0) {
            secciones = this.expediente.secciones;
        }
        for (const paso of event) {
            let seccion = {
                origen: paso.nombre,
                propiedades: paso.origen !== 'detalle' ? this.validarObject(paso.outData) ? paso.outData : paso.inData : {'informacion': 'DETALLE'}
            };
            if(seccion.propiedades && seccion.propiedades.expediente){
                delete seccion.propiedades.expediente;
            }
            if (secciones && secciones.length > 0) {
                const indexObj = secciones.findIndex(element => element.origen === seccion.origen);
                if (indexObj != -1) {
                    const before = secciones[indexObj];
                    secciones[indexObj] = {...before, ...seccion};
                } else {
                    secciones.push(seccion);
                }
            } else {
                secciones.push(seccion);
            }
        }
        return secciones;
    }

    validarObject(obj) {
        return !(obj === undefined || obj === null || Object.keys(obj).length === 0);
    }

    validarInformacionVista() {
        if (!this.idExpediente) {
            return this.wizardInformacion;
        } else {
            return this.wizardInformacion && this.expediente;
        }
    }

    validarPermiso() {
        this.readOnly = false;
        //!AuthUtils.hasRol('CREAR_EXPEDIENTE');
    }

    definirFuncionesNegocio() {
        /**
         * Funcion para paso Datos de persona no localizada o desaparecida
         * Se encarga de calcular a partir de la fecha de nacimiento los campos
         * edad, edad en meses y edad en dias.
         */
        // this.businessData.addFunction('onChangeFechaNacimiento', function test(el) {
        //     const form: FormGroup = el['formulario'];
        //     const fechaNacimiento = new Date(form.controls['fechaNacimiento'].value);
        //     var today = new Date();
        //     var edad = today.getFullYear() - fechaNacimiento.getFullYear();
        //     var m = today.getMonth() - fechaNacimiento.getMonth();
        //     if (m < 0 || (m === 0 && today.getDate() < fechaNacimiento.getDate())) {
        //         edad--;
        //     }
        //     form.controls['edad'].setValue(edad.toString());
        //     const meses = today.getMonth() - fechaNacimiento.getMonth() + (12 * (today.getFullYear() - fechaNacimiento.getFullYear()))
        //     form.controls['edadMeses'].setValue((meses).toString());
        //     const diferencia = today.getTime() - fechaNacimiento.getTime();
        //     form.controls['edadDias'].setValue((diferencia / (1000 * 3600 * 24)).toString());
        // });

    }
    back(){
        this.backPage.next();
    }
}
